export default function LazyLoad() {
  return (
    <>
      <div class="loader-container">
        <div class="skeleton-loader">
          <div class="skeleton-line skeleton-title"></div>
          <div class="skeleton-line"></div>
          <div class="skeleton-line"></div>
          <div class="skeleton-line skeleton-short"></div>
        </div>
      </div>
    </>
  );
}
